import { API_ROOT } from '../constants'
import api from '../utils/api'

export const supportUpload = (formData, config) => api.post(`${API_ROOT}/v3/support/upload`, formData, config)
